import { PrimeNGConfig } from 'primeng/api';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, inject, Inject, PLATFORM_ID } from '@angular/core';
SwiperCore.use([Autoplay, Pagination, Navigation, EffectFade]);
// remove: import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import SwiperCore, { Autoplay, Pagination, Navigation, EffectFade } from 'swiper';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  title = 'paredes-y-asociados-front';

  constructor(
    private primengConfig: PrimeNGConfig,
    // remove: private analytics: AngularFireAnalytics,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    // remove: this.analytics.setAnalyticsCollectionEnabled(true);
  }


  ngOnInit() {
    this.primengConfig.setTranslation({
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      today: 'Hoy',
      clear: 'Limpiar',
      firstDayOfWeek: 1,
      emptyMessage: 'No se encontraron resultados'
    });

  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      import('aos').then(({ default: AOS }) => {
        const run = () => {
          AOS.init({
            once: true,
            offset: 50,
            duration: 500,
            easing: 'ease-in-out',
          });
          AOS.refresh();
        };

        const anyWindow = window as unknown as { requestIdleCallback?: (cb: () => void) => void };
        if (anyWindow.requestIdleCallback) {
          anyWindow.requestIdleCallback(run);
        } else {
          setTimeout(run, 1);
        }
      });
    }
  }

}
